
export enum CalendarEventSource {
    BOOKING = 'BOOKING',
    HOST_BOOKING = 'HOST_BOOKING',
    GOOGLE_CALENDAR_SYNCED_BOOKING = 'GOOGLE_CALENDAR_SYNCED_BOOKING'
}

export enum CalendarEventStatus {
    AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
    CONFIRMED = 'CONFIRMED',
    CANCELLED = 'CANCELLED'
}

export interface CalendarEvent {
    id: string;
    /** Present when the event is backed by a room booking (`source=BOOKING`). */
    roomBookingId?: string | null;
    source: CalendarEventSource;
    title: string;
    startTime: string;
    endTime: string;
    status: CalendarEventStatus;
    /** Booker profile display name when linked to a room booking user. */
    userName?: string | null;
    /** Booker phone (E.164). */
    phoneNumber?: string | null;
    /** Booker profile band for “Plays in …”. */
    bandName?: string | null;
}

export interface CalendarEventWithMemberInfo {
    id: string;
    userName: string;
    bandName: string;
    startTime: string;
    endTime: string;
}
